import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { IEmployees } from "./models";
import { employeeItems } from "./employee.mock";
import { memo, useCallback, useState } from "react";
import { Employee } from "./EmployeeForm/Employee";

const translationPath = "page.4uDlist.generationRule.employee.";

export const EmployeePage = memo(() => {
  const [employee, setEmployee] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const { t } = useTranslation();

  const { id } = useParams();

  const columns: GridColDef<IEmployees>[] = [
    {
      field: "sector",
      headerName: t(translationPath + "sector") || "Sector",
      renderCell: (params) => {
        if (!params.value) return "-";
        return (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    setEmployee(true);
  };

  const handleRowClick = (params: GridRowParams<IEmployees>) => {
    if (!params.row) return;
    setEmployee(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setEmployee(false);
  }, []);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {employee && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <Employee id={selectedId} onBackButton={handleBack} />
        </Box>
      )}
      {!employee && (
        <Box height={600}>
          <Table<IEmployees>
            showDefaultMacroFilters={false}
            rows={employeeItems}
            columns={columns}
            title={t(translationPath + "employees")}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputPlaceHolder={t(translationPath + "search")}
            addButtonLabel={
              t(translationPath + "add_employee") || "Add Employee"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
});
